import angular from 'angular';

import FormElemModule from './form-elem.directive';
import ValidatorModule from './validator.directive';

export default angular.module('control-room.commons.forms.directives', [FormElemModule.name, ValidatorModule.name]);
